import useRedux from "./useRedux";
import { useEffect } from "react";
import { project } from "../contract/config";
import { awaitWrap, checkHashStatus } from "../common/utilTools";
import { usePluginModel } from "./usePluginModel";

export function UseOperator() {
  const { storeData, dispatch } = useRedux();
  const { NewReadContract } = usePluginModel();

  useEffect(() => {
    if (storeData.address) {
      init();
    }
  },[storeData.address])

  async function init() {
    const contarct = NewReadContract(project.contracts.Proxy.address, project.contracts.DVOl.abi);
    // const [resData, error] = await awaitWrap(Promise.all([
    //   contarct.isOperator(storeData.address),
    //   contarct.owner(storeData.address),
    // ]));
    const [resData, error] = await awaitWrap(contarct.owner());
    if (resData) {
      // dispatch.setIsOperator(resData[0]);
      dispatch.setIsAdmin(resData === storeData.address);
    }
  }

  return <></>;
}
